export const splitCommaSeparatedStringToArrayOfNums = (value) => value.split(',').map((v) => +v);

export const stringIsInt = (value) => /^[0-9]+$/.test(value);

export const isEmpty = (value) => {
    if (value == null) return true;
    if (typeof value === 'string') return !value.trim();
    if (typeof value === 'object') return !Object.keys(value).length;

    return !value;
};
